import React from 'react';
import { useSelector } from 'react-redux';
import { useAppointmentDetailsContext } from '../contexts/appointmentdetails.context';
import { USER_ROLES } from '../../../../utils/constants';
import RescheduleBtn from './reschedulebtn';
import CancelApptBtn from './cancelapptbtn';
import PayNowBtn from './paynowbtn';
import AcceptRejectBtn from './acceptrejectbtn';
import MarkAsComplete from './markascomplete';

const ApointmentActions = () => {
    const userInfo = useSelector(state => state.auth.user);
    const { appointmentDetails } = useAppointmentDetailsContext();

    // const downloadPrescription = () => {
    //     createDownloadLink(appointmentDetails.prescription);
    // };

    const patientActions = () => {
        const cancelBtn = !['COMPLETED', 'CANCELLED'].includes(appointmentDetails.status) && <CancelApptBtn />;
        const rescheduleBtn = ['CONFIRMED', 'PENDING'].includes(appointmentDetails.status) && <RescheduleBtn />;
        const payNowBtn = ['UNPAID', 'FAILED'].includes(appointmentDetails.paymentStatus) && <PayNowBtn />;

        return (
            <>
                {payNowBtn}
                {cancelBtn}
                {rescheduleBtn}
            </>
        );
    };

    const doctorActions = () => {
        const acceptRejectBtn = appointmentDetails.paymentStatus === 'PAID' && appointmentDetails.status === 'PENDING' && <AcceptRejectBtn />;
        const completeAppointment = appointmentDetails && appointmentDetails.prescription && <MarkAsComplete />;
        const confirmedActions = () => {
            // const uploadprescription = appointmentDetails.appointmentType !== 1 && <UploadPrescription />; // Prescriptions can be uploaded in case of tele consultation only
            return appointmentDetails.status === 'CONFIRMED' && (
                <>
                    <RescheduleBtn />
                    {completeAppointment}
                </>
            );
        };

        return (
            <>
                {acceptRejectBtn}
                {confirmedActions()}
            </>
        );
    };

    const apptActionsUI = () => {
        const allowedForDoctorActions = (role) => [USER_ROLES.DOCTOR, USER_ROLES.SUPER_ADMIN].includes(role);
        if (userInfo && userInfo.role && allowedForDoctorActions(userInfo.role)) {
            return doctorActions();
        }

        return patientActions();
    };

    // const prescriptionBtn = appointmentDetails.prescription && <Button color="primary" variant="contained" onClick={downloadPrescription}> <FileDownloadIcon />&nbsp;Prescription </Button>;

    return (
        <div className='appt-actions-container'>
            {/* {prescriptionBtn} */}
            {apptActionsUI()}
        </div>
    );
};

export default ApointmentActions;